import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies';
import * as _ from 'lodash';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { throwError, Subject } from 'rxjs';
//import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common/http";
import * as i3 from "ngx-spinner";
var Foo = /** @class */ (function () {
    function Foo(result) {
        this.result = result;
    }
    return Foo;
}());
export { Foo };
var AppService = /** @class */ (function () {
    function AppService(_router, _http, spinnerService) {
        this._router = _router;
        this._http = _http;
        this.spinnerService = spinnerService;
        this.regenerateCaptchaSubject = new Subject();
        this.regenerateCaptcha$ = this.regenerateCaptchaSubject.asObservable();
    }
    AppService.prototype.obtainAccessToken = function (loginData) {
        var _this = this;
        var params = new URLSearchParams();
        params.append('username', loginData.username);
        params.append('password', loginData.password);
        params.append('grant_type', 'password');
        params.append('client_id', 'oauth_client_id');
        //params.append('client_id','oauth_client_id');
        var headers = new HttpHeaders({ 'Content-type': 'application/x-www-form-urlencoded; charset=utf-8', 'Authorization': 'Basic ' + btoa("oauth_client_id:secret") });
        var options = { headers: headers, responseType: 'json' };
        /*
        let options: {
          headers?: HttpHeaders | {[header: string]: string | string[]},
          observe?: 'body' | 'events' | 'response',
          params?: HttpParams|{[param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>},
          reportProgress?: boolean,
          responseType?: 'arraybuffer'|'blob'|'json'|'text',
          withCredentials?: boolean,
      }
    */
        console.log(params.toString());
        this._http.post(environment.authServer + '/auth/api/oauth/token', params.toString(), { headers: headers, responseType: 'json' })
            // .map(res => res.json())
            .subscribe(function (data) { return _this.saveToken(data); }, function (err) {
            alert('Invalid Sms code');
            _this.spinnerService.hide();
            _this._router.navigate(['/prelogin', loginData.username]);
        });
    };
    AppService.prototype.confirm = function (transaction_id) {
        var _this = this;
        console.log("confirm transaction: " + environment.apiServer + ("/api/client/confirm/intent/" + transaction_id));
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.apiServer + ("/api/client/confirm/intent/" + transaction_id), null, { headers: headers, responseType: 'json', observe: 'response' })
            // .map(res => res.json())
            .subscribe({
            next: function (data) {
                console.log("confirm transaction data: " + data);
                // torniamo al wallet
                _this._router.navigate(['/wallet']);
            },
            error: function (error) {
                alert('Invalid confirm ' + JSON.stringify(error));
                _this.spinnerService.hide();
                _this._router.navigate(['/wallet']);
            }
        });
    };
    AppService.prototype.cancel = function (transaction_id) {
        var _this = this;
        console.log("cancel transaction");
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.apiServer + ("/api/client/cancel/intent/" + transaction_id), null, { headers: headers, responseType: 'json', observe: 'response' })
            // .map(res => res.json())
            .subscribe({
            next: function (data) {
                console.log("cancel transaction data: " + data);
                // torniamo al wallet
                _this._router.navigate(['/wallet']);
            },
            error: function (error) {
                alert('Invalid confirm ' + JSON.stringify(error));
                _this.spinnerService.hide();
                _this._router.navigate(['/wallet']);
            }
        });
        /*
        .subscribe(
          data => {
            console.log("cancel transaction data: "+ data);
            this._router.navigate(['/wallet']);
          },
          err => {
            alert('Invalid cancel ' + JSON.stringify(err.error));
            this.spinnerService.hide();
            this._router.navigate(['/wallet']);
            // this._router.navigate(['/prelogin', loginData.username]);
          });
          */
    };
    AppService.prototype.preLogin = function (loginData) {
        var _this = this;
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.authServer + '/auth/public/app/prelogin', JSON.stringify(loginData), { headers: headers, responseType: 'json', observe: 'response' })
            // .map(res => res.json())
            .subscribe(function (data) {
            _this.spinnerService.hide();
            console.log(data);
            if (data.status == 200) {
                _this._router.navigate(['/login', loginData.phone]);
            }
            else {
                alert("INVALID OR NOT EXISTING PIN");
                _this._router.navigate(['/prelogin', loginData.phone]);
            }
        }, function (err) {
            console.log(err);
            alert('Invalid Credentials');
            _this.spinnerService.hide();
        });
    };
    AppService.prototype.preChangePin = function (loginData) {
        var _this = this;
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.authServer + '/auth/public/app/prechangepin', JSON.stringify(loginData), { headers: headers, responseType: 'json', observe: 'response' })
            // .map(res => res.json())
            .subscribe(function (data) {
            _this.spinnerService.hide();
            console.log(data);
            if (data.status == 200) {
                _this._router.navigate(["/changepin/" + loginData.phone + "/" + loginData.pin]);
            }
            else {
                alert("INVALID OR NOT EXISTING PIN");
                _this._router.navigate(['/prechangepin', loginData.phone]);
            }
        }, function (err) {
            console.log(err);
            alert('Invalid Credentials');
            _this.spinnerService.hide();
        });
    };
    AppService.prototype.register = function (registerData) {
        var _this = this;
        var params = new URLSearchParams();
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.authServer + '/auth/public/app/signup', JSON.stringify(registerData), { headers: headers, responseType: 'json' })
            .subscribe(function (data) {
            console.log(data);
            _this.spinnerService.hide();
            _this._router.navigate(["/prelogin/" + registerData.username + "/" + registerData.password]);
            // this._router.navigate(['/login', registerData.username]);
            // this.preLogin({ phone: registerData.username, pin: registerData.password});
            // this.obtainAccessToken(registerData);
        }, function (err) {
            console.log(err);
            _this.spinnerService.hide();
            if (err.status == 409) {
                alert('User exists');
                _this._router.navigate(['/prelogin', registerData.username]);
            }
            else {
                alert('Invalid SignUp');
            }
        });
        /*
        console.log(params.toString());
         this._http.post('http://localhost:8091/public/app/signUp', params.toString(), options)
        .map(res => res.json())
        .subscribe(
          data => {
            console.log(data);
            // this.saveToken(data)
          },
          err => {alert('Invalid SignUp'); this.spinnerService.hide()});
        );
        */
    };
    AppService.prototype.changepin = function (registerData) {
        var _this = this;
        var params = new URLSearchParams();
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.authServer + '/auth/public/app/changepin', JSON.stringify(registerData), { headers: headers, responseType: 'json' })
            .subscribe(function (data) {
            console.log(data);
            // this._router.navigate(['/login', registerData.phone]);
            // this.preLogin({ phone: registerData.username, pin: registerData.password});
            // this.obtainAccessToken({username: registerData.phone, password: registerData.code});
        }, function (err) {
            console.log(err);
            _this.spinnerService.hide();
            if (err.status == 200) {
                alert('Pin changed!');
                // this._router.navigate(['/prelogin', registerData.username]);
                _this.obtainAccessToken({ username: registerData.phone, password: registerData.code });
            }
            else {
                alert('Error changing the pin');
            }
        });
        /*
        console.log(params.toString());
         this._http.post('http://localhost:8091/public/app/signUp', params.toString(), options)
        .map(res => res.json())
        .subscribe(
          data => {
            console.log(data);
            // this.saveToken(data)
          },
          err => {alert('Invalid SignUp'); this.spinnerService.hide()});
        );
        */
    };
    AppService.prototype.ccpay = function (registerData) {
        var _this = this;
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.apiServer + '/api/v1/payment-methods/payments', JSON.stringify(registerData), { headers: headers, responseType: 'json', observe: 'response' })
            // .map(res => res.json())
            .subscribe({
            next: function (data) {
                _this.spinnerService.hide();
                console.log("confirm transaction data: " + data);
                location.href = data.body["payment_url"];
                // torniamo al wallet
                // this._router.navigate(['/wallet']);
            },
            error: function (error) {
                alert('Invalid confirm ' + JSON.stringify(error));
                _this.spinnerService.hide();
                //this._router.navigate(['/wallet']);
            }
        });
    };
    AppService.prototype.ccpay1 = function (registerData) {
        var _this = this;
        var params = new URLSearchParams();
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.apiServer + '/api/v1/payment-methods/payments', JSON.stringify(registerData), { headers: headers, responseType: 'json' })
            .subscribe(function (data) {
            console.log(data);
            // this._router.navigate(['/login', registerData.phone]);
            // this.preLogin({ phone: registerData.username, pin: registerData.password});
            // this.obtainAccessToken({username: registerData.phone, password: registerData.code});
        }, function (err) {
            console.log(err);
            _this.spinnerService.hide();
            if (err.status == 200) {
                //alert('Pin changed!');
                // this._router.navigate(['/prelogin', registerData.username]);
                //this.obtainAccessToken({ username: registerData.phone, password: registerData.code });
            }
            else {
                alert('Error paying');
            }
        });
    };
    AppService.prototype.execIntent = function (mintid, user_id) {
        var _this = this;
        var params = new URLSearchParams();
        console.log("execIntent");
        // mandargli lo user_id
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.apiServer + ("/api/client/exec/intent/" + mintid), "{\"user_id\":\"" + user_id + "\"}", { headers: headers, responseType: 'json', observe: 'response' })
            .subscribe(function (data) {
            console.log(data);
            // alert(data.status);
            // check for status if is 206 (partial content) mean that the identity check doesnt exuists so must be performed
            // if 201 was a payment and the transaction is ready to be confirmed
            // if 200 was a age check and we can get the redirect url form
            /// got redirect url from intent if age check otherwise ask confirmation or cancel transaction
            /// location.href = data
            // if intent was for age check
            // ask confirmation before because here happen the fee charge to merchant
            // ????? update intent using endpoint for this .. (which?)
            // if intent is for payment 
            // if 201 was a payment and the transaction is ready to be confirmed
            if (data.status == 201) {
                var text = "Confirm payment!\nAmount: " + data.body['amount'] + " " + data.body['currency'] + "\nto: ";
                if (confirm(text) == true) {
                    _this.confirm(mintid);
                    alert("Payment Confirmed!");
                }
                else {
                    _this.cancel(mintid);
                    alert("Payment Cancelled");
                }
            }
            if (data.status == 200) {
                //TODO: how to charge or not the merchant ?????
                // location.href = data.body["redirect_uri"];
                var text = "Confirm : ";
                if (confirm(text) == true) {
                    _this.confirmIntent(mintid, user_id);
                    alert("Age check Confirmed!");
                }
                else {
                    // this.cancel(data.body['id'])
                    alert("Age check Cancelled");
                }
                _this._router.navigate(['/']);
            }
            if (data.status == 206) {
                //TODO: how to charge or not the merchant ?????
                _this.getTransactionId();
                _this._router.navigate([data.body["redirect_uri"]]);
            }
            _this.spinnerService.hide();
        }, function (err) {
            console.log(err);
            _this.spinnerService.hide();
            if (err.status == 200) {
                alert("success");
                _this._router.navigate(['/']);
            }
            else {
                alert('Error executing intent: \n' + JSON.stringify(err.error));
                _this._router.navigate(['/']);
            }
        });
        /*
        console.log(params.toString());
         this._http.post('http://localhost:8091/public/app/signUp', params.toString(), options)
        .map(res => res.json())
        .subscribe(
          data => {
            console.log(data);
            // this.saveToken(data)
          },
          err => {alert('Invalid SignUp'); this.spinnerService.hide()});
        );
        */
    };
    AppService.prototype.confirmIntent = function (mintid, user_id) {
        var _this = this;
        var params = new URLSearchParams();
        console.log("confirmIntent");
        // mandargli lo user_id
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.apiServer + ("/api/client/confirm/intent/" + mintid), null, { headers: headers, responseType: 'text', observe: 'response' })
            .subscribe(function (data) {
            console.log(data);
            _this.spinnerService.hide();
        }, function (err) {
            console.log(err);
            _this.spinnerService.hide();
            if (err.status == 202) { //accepted
                alert("Accepted");
                _this._router.navigate(['/']);
            }
            else {
                alert('Error confirming intent: \n' + JSON.stringify(err.error));
                _this._router.navigate(['/']);
            }
        });
        /*
        console.log(params.toString());
         this._http.post('http://localhost:8091/public/app/signUp', params.toString(), options)
        .map(res => res.json())
        .subscribe(
          data => {
            console.log(data);
            // this.saveToken(data)
          },
          err => {alert('Invalid SignUp'); this.spinnerService.hide()});
        );
        */
    };
    AppService.prototype.getJwtToken = function () {
        return Cookie.get('access_token');
    };
    AppService.prototype.saveToken = function (token) {
        var expireDate = new Date().getTime() + (1000 * token.expires_in);
        Cookie.set("access_token", token.access_token, expireDate);
        Cookie.set("refresh_access_token", token.refresh_token, expireDate);
        console.log('Obtained Access token: ' + token.access_token);
        this._router.navigateByUrl('/consent');
        // this._router.navigate(['/']);
    };
    AppService.prototype.getResource = function (resourceUrl) {
        console.log("resourceUrl: " + resourceUrl);
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        return this._http.get(environment.apiServer + resourceUrl, { headers: headers, responseType: 'json' })
            // .map((res:Response) => res.json())
            .pipe(retry(1), catchError(this.handleError));
    };
    AppService.prototype.getTransactionId = function () {
        console.log("getTransactionId");
        this.spinnerService.show();
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        // this.spinnerService.hide();
        return this._http.get(environment.apiServer + "/api/idcheck/init", { headers: headers, responseType: 'json' })
            // .map((res:Response) => res.json())
            .pipe(retry(1), catchError(this.handleError));
    };
    AppService.prototype.getNfcTransactionId = function () {
        Cookie.get('consensus');
        var consensus = Cookie.get('consensus') ? Cookie.get('consensus') : 'false';
        console.log("getTransactionId");
        this.spinnerService.show();
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        // this.spinnerService.hide();
        return this._http.get(environment.apiServer + ("/api/idcheck/initnfc?nfc_consensus=" + consensus), { headers: headers, responseType: 'json' })
            // .map((res:Response) => res.json())
            .pipe(retry(1), catchError(this.handleError));
    };
    AppService.prototype.getMyWallets = function () {
        console.log("getMyWallets");
        this.spinnerService.show();
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        // this.spinnerService.hide();
        return this._http.get(environment.apiServer + ("/api/user/wallets/" + _.get(user, 'bank_user_id')), { headers: headers, responseType: 'json' })
            // .map((res:Response) => res.json())
            .pipe(retry(1), catchError(this.handleError));
    };
    /*
    this.http.post('http://localhost:8090/registro', formData, {
      observe: 'response', responseType: 'text' })
      .subscribe({ next: (response) => console.log('Response:', response.body),
       error: (error) => console.log('Error:', error.error), });
  
  
    async pay(source_wallet_id, destination_wallet_id, amount) {
  
      this.spinnerService.show();
  
      const payload =
      {
        "receiver_account": destination_wallet_id,
        "amount": amount,
        "currency": "eur",
        "details": "Payment",
        "payment_type": "internal"
      }
  
  
      let headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
  
      this._http.post(environment.apiServer + `/api/wallets/transaction/${source_wallet_id}`, JSON.stringify(payload), { headers, responseType: 'json', observe: 'response' })
        // .map(res => res.json())
        .subscribe(
          data => {
  
            console.log(data);
            let text = `Confirm payment!\nAmount: ${data.body['amount']} ${data.body['currency']}\nto: `;
            if (confirm(text) == true) {
              this.confirm(data.body['id'])
              alert("Payment Confirmed!");
            } else {
              this.cancel(data.body['id'])
              alert("Payment Cancelled");
            }
            this.spinnerService.hide();
          },
          err => {
            console.log(err);
            alert('Error Sending Payment');
            this.spinnerService.hide();
          });
  
    }
  
    */
    AppService.prototype.enablePayments = function (questionaire) {
        var _this = this;
        console.log("enablePayments");
        /// TODO: CHECK IF IS IDENTIFICATION COMPLETE STATUS
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (_.get(user, 'bank_user_id') ? true : false) {
            this.sendQuestionaryData(_.get(user, 'bank_user_id'), questionaire);
        }
        else {
            var currentData = void 0;
            var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
            this._http.post(environment.apiServer + '/api/user/enable_payments', JSON.stringify({ "email": "foo@bar.com" }), { headers: headers, responseType: 'json', observe: 'response' })
                // .map(res => res.json())
                .subscribe(function (data) {
                _this.spinnerService.hide();
                console.log("posted enable_payments: " + data.body['id']);
                _this.sendIdentityData(data.body['id'], questionaire);
                localStorage.setItem('currentUser', JSON.stringify(data));
                /*
                
                if (data.status == 200) {
                  this._router.navigate(['/login', loginData.phone]);
                } else {
                  alert("INVALID OR NOT EXISTING PIN");
                  this._router.navigate(['/prelogin', loginData.phone]);
                }
                */
            }, function (err) {
                console.log(err);
                if (err.status == 400) { // user already exist
                    // this.sendIdentityData(data.body['id'], questionaire);
                    _this.sendIdentityData(err.error.reason.additional_data.id, questionaire);
                }
                else {
                    alert('Error Enabling Payment: ' + JSON.stringify(err));
                }
                _this.spinnerService.hide();
            });
        }
    };
    AppService.prototype.sendIdentityData = function (kern_user_id, questionaire) {
        var _this = this;
        console.log("sendIdentityData");
        /// TODO: CHECK IF IS IDENTIFICATION COMPLETE STATUS
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.apiServer + ("/api/user/identity/" + kern_user_id), null, { headers: headers, responseType: 'json', observe: 'response' })
            // .map(res => res.json())
            .subscribe(function (data) {
            _this.spinnerService.hide();
            console.log("Posted identity data" + data);
            // const user = JSON.parse(localStorage.getItem('currentUser'));
            _this.sendQuestionaryData(kern_user_id, questionaire);
            // this._router.navigate(['/wallet']);
            /*
            
            if (data.status == 200) {
              this._router.navigate(['/login', loginData.phone]);
            } else {
              alert("INVALID OR NOT EXISTING PIN");
              this._router.navigate(['/prelogin', loginData.phone]);
            }
            */
        }, function (err) {
            console.log(err);
            alert('Error sendIdentityData');
            _this.spinnerService.hide();
        });
        /*
           let headers = new HttpHeaders({'Content-type': 'application/json; charset=utf-8'});
       
            this._http.post(environment.authServer +'/api/user/enable_payments',JSON.stringify(data),{ headers, responseType: 'json' })
            .subscribe(data => {
              console.log(data);
              this.spinnerService.hide();
              // this._router.navigate([`/prelogin/${registerData.username}/${registerData.password}`]);
              // this._router.navigate(['/login', registerData.username]);
              // this.preLogin({ phone: registerData.username, pin: registerData.password});
              // this.obtainAccessToken(registerData);
            },
            err => {
              console.log(err);
              this.spinnerService.hide()
              if (err.status == 409) {
                alert('User exists');
                // this._router.navigate(['/prelogin', registerData.username]);
              } else {
                alert('Invalid SignUp');
              }
              */
    };
    AppService.prototype.sendQuestionaryData = function (kern_user_id, data) {
        var _this = this;
        console.log("sendQuestionaryData");
        this.spinnerService.show();
        /// TODO: CHECK IF IS IDENTIFICATION COMPLETE STATUS
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.apiServer + ("/api/user/questionnaire/" + kern_user_id), JSON.stringify(data), { headers: headers, responseType: 'json', observe: 'response' })
            // .map(res => res.json())
            .subscribe(function (data) {
            _this.spinnerService.hide();
            console.log("sendQuestionaryData: " + data);
            _this._router.navigate(['/wallet']);
            /*
            
            if (data.status == 200) {
              this._router.navigate(['/login', loginData.phone]);
            } else {
              alert("INVALID OR NOT EXISTING PIN");
              this._router.navigate(['/prelogin', loginData.phone]);
            }
            */
        }, function (err) {
            console.log(err);
            alert('Error questionnaire');
            _this.spinnerService.hide();
        });
        /*
           let headers = new HttpHeaders({'Content-type': 'application/json; charset=utf-8'});
       
            this._http.post(environment.authServer +'/api/user/enable_payments',JSON.stringify(data),{ headers, responseType: 'json' })
            .subscribe(data => {
              console.log(data);
              this.spinnerService.hide();
              // this._router.navigate([`/prelogin/${registerData.username}/${registerData.password}`]);
              // this._router.navigate(['/login', registerData.username]);
              // this.preLogin({ phone: registerData.username, pin: registerData.password});
              // this.obtainAccessToken(registerData);
            },
            err => {
              console.log(err);
              this.spinnerService.hide()
              if (err.status == 409) {
                alert('User exists');
                // this._router.navigate(['/prelogin', registerData.username]);
              } else {
                alert('Invalid SignUp');
              }
              */
    };
    AppService.prototype.refreshToken = function () {
        var _this = this;
        Cookie.delete("access_token"); // avoid to add BArear auth token
        // Cookie.delete("refresh_access_token");
        var headers = new HttpHeaders({ 'Content-type': 'application/x-www-form-urlencoded; charset=utf-8', 'Authorization': 'Basic ' + btoa("oauth_client_id:secret") });
        var params = new URLSearchParams();
        params.append('grant_type', 'refresh_token');
        params.append('refresh_token', Cookie.get('refresh_access_token'));
        // ?grant_type=refresh_token&refresh_token=[yourRefreshToken]"
        return this._http
            .post(environment.authServer + "/auth/api/oauth/token", params.toString(), { headers: headers, responseType: 'json' })
            .pipe(tap(function (tokens) {
            _this.saveToken(tokens);
            var currentUrl = _this._router.url;
            _this._router.navigateByUrl('/', { skipLocationChange: true }).then(function () {
                _this._router.navigate([currentUrl]);
            });
        }), catchError(function (error) {
            console.log("Refresh token error: ", error);
            _this.logout();
            return of(false);
        }));
    };
    AppService.prototype.checkCredentials = function () {
        if (!Cookie.check('access_token')) {
            this._router.navigate(['/prelogin']);
        }
    };
    AppService.prototype.logout = function () {
        var _this = this;
        var headers = new HttpHeaders({ 'Content-type': 'application/json; charset=utf-8' });
        this._http.post(environment.authServer + "/auth/public/app/logout", null, { headers: headers, responseType: 'text', observe: 'response' })
            .subscribe(function (data) {
            console.log(data);
            Cookie.delete('access_token');
            Cookie.delete("refresh_access_token"); // avoid to add BArear auth token
            _this._router.navigate(['/prelogin']);
            _this.spinnerService.hide();
        }, function (err) {
            console.log(err);
            _this.spinnerService.hide();
            // alert('Error logout: \n' + JSON.stringify(err));
            _this._router.navigate(['/']);
        });
    };
    // Error handling
    AppService.prototype.handleError = function (error) {
        var errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        }
        else {
            // Get server-side error
            errorMessage = "Error Code: " + error.status + "\nMessage: " + error.message;
        }
        console.log(errorMessage);
        return throwError(function () {
            return errorMessage;
        });
    };
    AppService.ngInjectableDef = i0.defineInjectable({ factory: function AppService_Factory() { return new AppService(i0.inject(i1.Router), i0.inject(i2.HttpClient), i0.inject(i3.NgxSpinnerService)); }, token: AppService, providedIn: "root" });
    return AppService;
}());
export { AppService };
